/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Absence_Reason_SicknessInputs */

const en_enum_absence_reason_sickness = /** @type {(inputs: Enum_Absence_Reason_SicknessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason Sickness`)
};

const de_enum_absence_reason_sickness = /** @type {(inputs: Enum_Absence_Reason_SicknessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund Sickness`)
};

/**
* | output |
* | --- |
* | "Reason Sickness" |
*
* @param {Enum_Absence_Reason_SicknessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_absence_reason_sickness = /** @type {((inputs?: Enum_Absence_Reason_SicknessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Absence_Reason_SicknessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_absence_reason_sickness(inputs)
	return de_enum_absence_reason_sickness(inputs)
});